import { getPartnerSignupType } from 'common/partnerHelpers';

import {
  PARTNER_SIGNUP_TYPE_SUN_SCREEN,
  PARTNER_SIGNUP_TYPE_SUN_RISE,
  PARTNER_SIGNUP_TYPE_FULL_SERVICE,
} from 'common/partnerConstants';

export function getHelpCardTitle({ partner }) {
  const partnerSignupType = getPartnerSignupType(partner);

  switch (partnerSignupType) {
    case PARTNER_SIGNUP_TYPE_SUN_SCREEN:
      return 'How SunScreen Works';
    case PARTNER_SIGNUP_TYPE_SUN_RISE:
      return 'How SunSetup Works';
    case PARTNER_SIGNUP_TYPE_FULL_SERVICE:
      return 'How Full-Service Leasing Works';
  }
}
